import ENV_TYPES from './env-types.enum';

const AppDefaultValuesEnum = {
  LANGUAGE_ID: 1,
  LANGUAGE: 'en',
  GAME_ID: 334,
  CURRENCY: 'USD',
  MODE: 'fun',
  APPLICATION_ID: process.env.REACT_APP_ENV === ENV_TYPES.PRODUCTION ? 15 : 1,
};

Object.freeze(AppDefaultValuesEnum);

export { AppDefaultValuesEnum };
